module.exports = __webpack_public_path__ + "img/UTDEER-7.2ec003bc.jpg";